export const HERO_VIDEO = "/hero.mp4";

// Curated, validated modern-Africa editorial imagery (design_guidelines.json)
const U = (id) => `https://images.unsplash.com/${id}?q=85&w=1600&auto=format&fit=crop`;

export const IMAGES = {
  heroPoster: U("photo-1562774207-e20d9ad4b566"),
  journeyInvestor: U("photo-1611432579402-7037e3e2c1e4"), // businesswoman, leadership
  journeyTourist: U("photo-1689155494424-d2337856fe3e"),
  journeyReturnee: U("photo-1577896849786-738ed6c78bd3"), // family of four, contemporary home
  journeyExpat: U("photo-1753685726310-a261e03d85d9"), // woman, modern apartment
  lagos: U("photo-1771495604392-2008757fb32a"),
  abuja: U("photo-1741991110666-88115e724741"),
  kigali: U("photo-1562774207-e20d9ad4b566"),
  nairobi: U("photo-1669127300649-940337f1487e"),
  accra: U("photo-1781504798134-31600e8579ba"),
  capeTown: U("photo-1626894169601-482d26b23f35"),
  zanzibar: U("photo-1499793983690-e29da59ef1c2"),
  marrakech: U("photo-1544161515-4ab6ce6db874"),
  dining: U("photo-1517248135467-4c7edcad34c4"),
  cultureArt: U("photo-1735605917461-4c1b77a6616f"),
  shopping: U("photo-1441984904996-e0b6ba687e04"),
  familyLuxury: U("photo-1578496781307-30c2b531c05a"),
  relocationFamily: U("photo-1606788075819-9574a6edfab3"),
  womanTraveller: U("photo-1787779350658-ee53ac6e5b4b"),
  coupleLifestyle: U("photo-1611620004612-60be0a7838dd"),
  womenSocial: U("photo-1765991735985-1816c5b1b055"),
  networkingMixed: U("photo-1573167101669-476636b96cea"),
  professionalsMixed: U("photo-1573164574397-dd250bc8a598"),
  weddingYoruba: U("photo-1618998584360-10a0c28eec0f"),
  weddingIgbo: U("photo-1668246153111-07549350eda7"),
  weddingAgbada: U("photo-1687952622898-4e9514a710d5"),
  weddingReception: U("photo-1780593194924-35f0343e738b"),
  events: U("photo-1724866976376-4b217d29a462"),
  staycation: U("photo-1600607687920-4e2a09cf159d"),
  cityStyle: U("photo-1490481651871-ab68de25d43d"),
  guideFree: U("photo-1675649957429-8e867e45f800"),
  guideTourist: U("photo-1553531384-cc64ac80f931"),
  guideExpat: U("photo-1786886357716-9a6e0defb748"),
  airport: U("photo-1436491865332-7a61a109cc05"),
  concierge: U("photo-1686628269082-c92c3189903f"),
  community: U("photo-1573167101669-476636b96cea"),
  journalWoman: U("photo-1573497019418-b400bb3ab074"),
  personaChika: "/persona-chika.jpg", // 49, tailored blazer, gold jewellery (AI-polished edit of original portrait)
  personaIvy: U("photo-1589156280159-27698a70f29e"),
  personaGlenn: U("photo-1677107173222-6783dfea7326"), // smiling grey-haired man, blue shirt, full face
  airportTravel: U("photo-1653795163859-9ee39ecc6d62"),
  lagosSocial: U("photo-1731475761027-0b6b33b74547"),
  lagosSunny: U("photo-1618828665347-d870c38c95c7"),
  airportPassport: "/nigeria-passport.jpg", // real Nigerian passport (Wikimedia Commons, CC BY-SA 4.0)
  elizabeth: "/founder-elizabeth.jpg", // founder portrait (owner-supplied)
};

// Impact statistics — owner-supplied brand figures. Owner-updatable in admin → Settings.
export const IMPACT_STATS = [
  { value: "195K+", label: "Social Media Views" },
  { value: "5,000+", label: "Enquiries" },
  { value: "1,200+", label: "Guides Saved" },
  { value: "2,000+", label: "People Assisted" },
];

// Hero video slideshow — authentic African footage: Lagos skyline, lagoon boat life, Zanzibar blue water
export const HERO_VIDEOS = [
  { src: "/hero-2.mp4", poster: "/hero-2-poster.jpg", alt: "Speedboat cruising across the Lagos lagoon" },
  { src: "/hero-4.mp4", poster: "/hero-4-poster.jpg", alt: "Victoria Island, Lagos — premium waterfront skyline" },
  { src: "/hero-3.mp4", poster: "/hero-3-poster.jpg", alt: "Turquoise Indian Ocean waters off Zanzibar" },
];

export const SOCIALS = {
  tiktok: "https://www.tiktok.com/@jawaafrica",
  instagram: "https://www.instagram.com/jawa.africa/",
  youtube: "https://www.youtube.com/@J%C3%80W%C3%80Africa",
};

export const GOOGLE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSek_deDqrkYeHe6v7N7giQfl96f4GYoolOipYCSnkSEeWLZlw/viewform";

export const BESPOKE_COPY =
  "Tell us your interests, dates, group size, budget and preferred style — JÀWÀ shapes a bespoke itinerary around you and confirms every arrangement before anything is booked.";

// Emergency numbers — verified October 2026. Always confirm locally on arrival.
export const EMERGENCY = {
  nigeria: { label: "Nigeria", services: [["National emergency line", "112"], ["Lagos State emergency", "112 / 767"], ["Police (Lagos)", "112 / 767"]], note: "Coverage varies by state — confirm the working local numbers on arrival. Verified October 2026." },
  rwanda: { label: "Rwanda", services: [["Police", "112"], ["Ambulance", "912"]], note: "Verified October 2026 — confirm locally on arrival." },
  kenya: { label: "Kenya", services: [["National emergency", "999 / 112"], ["Ambulance (Nairobi)", "999 / 112"]], note: "Verified October 2026 — confirm locally on arrival." },
  ghana: { label: "Ghana", services: [["Police", "191"], ["Ambulance", "193"], ["Fire", "192"], ["National emergency", "112"]], note: "Verified October 2026 — confirm locally on arrival." },
  "south africa": { label: "South Africa", services: [["Police (SAPS)", "10111"], ["Ambulance & fire", "10177"], ["Mobile emergency", "112"]], note: "Verified October 2026 — confirm locally on arrival." },
  tanzania: { label: "Tanzania", services: [["National emergency", "112"], ["Police", "111"]], note: "Verified October 2026 — confirm locally on arrival." },
  morocco: { label: "Morocco", services: [["Police", "19"], ["Ambulance & fire", "15"]], note: "Verified October 2026 — confirm locally on arrival." },
};

// The four personas — original JÀWÀ profiles preserved, Expat added
export const PERSONAS = {
  investor: {
    name: "Chika",
    meta: "49 · Entrepreneur · Atlanta, USA",
    title: "The Investor",
    kicker: "Invest",
    image: IMAGES.personaChika,
    meet: "Chika is 49, an entrepreneur in Atlanta, and wants to explore investment opportunities in Lagos.",
    lookingFor:
      "A clear way to research opportunities, identify reputable professionals, understand the property landscape, conduct proper due diligence and plan productive visits — before committing capital.",
    frustrations: "Ready to tap into Africa's booming markets but unsure where to start?",
    barriers: "Heard too many horror stories about fake land, shady businesses, and risky deals?",
    needs: [
      "Verified lawyers, brokers and consultants — not whoever answers first",
      "A property landscape briefing: titles, districts and honest price ranges",
      "A pre-purchase checklist and due-diligence process she can trust",
      "A structured research visit — inspections, bank meetings, site tours",
    ],
    howHelp:
      "We connect you with verified lawyers, brokers, consultants, and investment experts you can trust — no 'wayo', just real wins.",
    strapline: "Build your empire back home with confidence. JAWA's got your back!",
    guideCta: "Investor A–Z Collection",
    disclaimer:
      "JÀWÀ provides orientation and introductions — not regulated financial, legal or investment advice, and no investment outcome is ever guaranteed. Qualified professionals should review every decision.",
  },
  tourist: {
    name: "Ivy",
    meta: "28 · Content creator · Canada",
    title: "The Tourist",
    kicker: "Visit",
    image: IMAGES.personaIvy,
    meet: "Ivy is 28, a Canadian content creator planning her first Detty December in Nigeria — and she wants the real Lagos, beautifully documented.",
    lookingFor:
      "The real Nigerian vibe — events and experiences worth sharing, vetted drivers and glam teams, people to meet and places her followers haven't seen a hundred times.",
    frustrations: "Dreaming of Detty December, epic family holidays, and reconnecting with the real Lagos vibes?",
    barriers: "Unsure where to book, where to hang out, and scared of falling into tourist traps?",
    needs: [
      "An arrival that runs itself — pickup, SIM and first-night plan",
      "Verified drivers, vetted stays and trusted glam squads",
      "The events, rooftops and beach clubs actually worth her December",
      "Someone to call when plans change at midnight",
    ],
    howHelp:
      "From verified drivers, glam teams, to family-friendly events, JAWA's your trusted Lagos plug — all good vibes, no stress.",
    strapline: "Book with confidence, party with peace of mind. Your Lagos adventure starts here!",
    guideCta: "Tourist A–Z Collection",
  },
  returnee: {
    name: "Tolu",
    meta: "37 · NHS Project Manager · returning with Halima, Trinity (5) and Toby (2)",
    title: "The Returnee & Relocator",
    kicker: "Return",
    image: IMAGES.journeyReturnee,
    meet: "Tolu is 37, an NHS project manager, married to Halima — they have a daughter, Trinity (5) and a son, Toby (2). After years abroad, they're coming home for good.",
    lookingFor:
      "A move handled as one project: the right home, the right school for Trinity, trusted help at home, and a community waiting on arrival.",
    frustrations: "Tired of the abroad hustle? Craving to reconnect with your roots, family, and real community?",
    barriers: "Worried about getting scammed? Unsure who to trust with finding a home, schools, or setting up your new life?",
    needs: [
      "Verified agents and a property checklist before money moves",
      "School research with the right questions to ask",
      "Vetted domestic staff, drivers and household setup",
      "A community of returnees who've already made the move",
    ],
    howHelp:
      "JAWA links you with verified agents, trusted service providers, and a supportive community ready to welcome you home — stress-free.",
    strapline: "Let's help you relocate smarter, faster, and with real vibes. Start your journey today!",
    guideCta: "Returnee A–Z Collection",
  },
  expat: {
    name: "Glenn S.",
    meta: "56 · Oil & gas engineer · relocating for work",
    title: "The Expat",
    kicker: "Settle",
    image: IMAGES.personaGlenn,
    meet: "Glenn S. is 56, an oil-and-gas engineer relocating to Nigeria for professional work. It's not his first posting — but Nigeria is new territory.",
    lookingFor:
      "A landing that doesn't eat his first month: accommodation sorted, airport pickup waiting, transport and connectivity working from day one — while he focuses on the job.",
    frustrations:
      "Unfamiliar processes everywhere, little time to learn them, and no reliable way to know which providers to trust.",
    barriers:
      "Coordinating practical arrangements from overseas, understanding what local banking actually requires, and avoiding delays that reflect badly in a new role.",
    needs: [
      "Arrival concierge and airport pickup that actually shows up",
      "Serviced accommodation and a vetted daily driver",
      "SIM registration and connectivity on day one",
      "Guidance on Nigerian banking requirements — subject to each bank's rules and eligibility",
    ],
    howHelp:
      "JAWA gives Glenn one accountable point of contact for the practical layer: arrival concierge, accommodation coordination, SIM assistance, transport and local orientation — with clear signposting to banks and official processes where requirements apply.",
    strapline: "Start the role, not the logistics. JAWA handles the ground game.",
    guideCta: "Expat A–Z Collection",
  },
};

export const MEMBERSHIP_BENEFITS = {
  investor: [
    "Full access to the members-only Investor A–Z online collection",
    "The JAWA pre-purchase property checklist and due-diligence framework",
    "Curated market and sector orientation resources",
    "Introductions pathway to verified lawyers, brokers and consultants",
    "Access to contact the JÀWÀ concierge for separately priced services",
  ],
  tourist: [
    "Full access to the members-only Tourist A–Z online collection",
    "The free Nigerian Airport Guide plus members' itinerary resources",
    "Curated events, dining and experiences directories",
    "Vetted driver, stay and glam-team recommendations",
    "Access to contact the JÀWÀ concierge for separately priced services",
  ],
  returnee: [
    "Full access to the members-only Returnee A–Z online collection",
    "The relocation pre-arrival checklist and school research framework",
    "Housing, agent and domestic-staff guidance resources",
    "Settling-in utilities, documents and household setup walkthroughs",
    "Access to contact the JÀWÀ concierge for separately priced services",
  ],
  expat: [
    "Full access to the members-only Expat A–Z online collection",
    "Arrival, banking-requirements and permits orientation resources",
    "Accommodation, driver and everyday-services directories",
    "Healthcare and schools signposting resources",
    "Access to contact the JÀWÀ concierge for separately priced services",
  ],
};

export const FAQ_ITEMS = [
  { q: "What is JÀWÀ AFRICA?", a: "JÀWÀ AFRICA is a premium African lifestyle, travel, relocation and investment platform. We help tourists, investors, returnees and expats experience, explore, invest in and make a life in Africa — beginning with Nigeria — through A–Z guides, memberships, concierge services and a vetted services directory." },
  { q: "Who is JÀWÀ for?", a: "Four kinds of travellers: Investors exploring opportunities, Tourists visiting for leisure, Diaspora Returnees and Relocators moving home, and Expats moving for work. Each has a dedicated journey, guide collection and membership." },
  { q: "What countries and destinations does JÀWÀ cover?", a: "Nigeria in depth — all 36 states and the Federal Capital Territory — plus a growing set of African cities including Abuja, Kigali, Accra, Nairobi, Cape Town, Zanzibar and Marrakech." },
  { q: "What is the difference between the four personas?", a: "Each persona answers a different life situation: the Investor researches and commits capital; the Tourist visits and experiences; the Returnee or Relocator moves home permanently; the Expat relocates for a work posting. Their guides, services and memberships are tailored accordingly." },
  { q: "How does the airport concierge service work?", a: "Tell us your flight details on WhatsApp and we coordinate your arrival: meet-and-greet guidance, immigration support where permitted, and a vetted driver waiting at arrivals. The free Nigerian Airport Guide PDF covers the full preparation checklist." },
  { q: "Can JÀWÀ help arrange airport pickup and accommodation?", a: "Yes — JAWA DRIVE handles airport pickups and daily drivers, and JAWA STAY coordinates verified short and long-term accommodation. Both are arranged through our concierge on WhatsApp." },
  { q: "How do I get a Nigerian SIM card?", a: "SIM registration requires your passport and a biometric capture at an official service centre. JAWA TOURIST and arrival support walk you through it on day one so your phone works from the airport onwards." },
  { q: "Can JÀWÀ help me research schools?", a: "Yes. We help you build a shortlist, understand admissions timelines and prepare the right questions. Enrolment decisions and applications remain yours — we guide, you decide." },
  { q: "Can JÀWÀ help with relocation and domestic staffing?", a: "Yes — JAWA RELOCATION provides 30-day concierge support for new returnees, and the A–Z directory includes vetted domestic staff coordination. Candidates are referenced and vetted; employment terms are agreed between you and the staff member." },
  { q: "Can JÀWÀ help me find property agents?", a: "We introduce reputable, referenced agents and share our pre-purchase checklist. We coordinate and introduce — the agent relationship, negotiation and transaction are yours, always with your own lawyer verifying title." },
  { q: "Does JÀWÀ guarantee investment returns or property legitimacy?", a: "No — and you should be cautious of anyone who does. We provide orientation, checklists and introductions to verified professionals. Independent legal and financial due diligence is essential on every transaction." },
  { q: "How do I access the free A–Z Guide?", a: "On the A–Z Guides page, enter your email and tick the consent box — the guide is emailed to you when released, and appears for immediate download once available." },
  { q: "How do I access the free Nigerian Airport Guide PDF?", a: "Open the A–Z Guides page and use the 'Download the Free Nigerian Airport Guide' button — no payment or membership needed." },
  { q: "How do paid A–Z guides and memberships work?", a: "Each audience collection (Investor, Tourist, Returnee, Expat) is members-only online content. Choose your membership, register with your email, and request payment details — once your payment is verified, your collection unlocks in your member area for the membership period." },
  { q: "What are the monthly and annual membership prices?", a: "Agreed launch prices: Tourist £4.99/$5/€5/₦7,500 monthly or £49.99/$50/€50/₦75,000 annual; Returnee £7.99/$8/€8/₦15,000 or £79.99/$80/€80/₦150,000; Expat £11.99/$12/€12/₦20,000 or £119.99/$120/€120/₦200,000; Investor £14.99/$15/€15/₦25,000 or £149.99/$150/€150/₦250,000. These are the agreed local launch prices per currency, not live exchange-rate conversions." },
  { q: "How do I pay by bank transfer?", a: "Choose your membership and plan, register your email, then tap 'Request Payment Details on WhatsApp'. We reply with the correct bank details for your currency. After your transfer arrives and is verified, your membership is activated and confirmed by email." },
  { q: "Why do I need to contact JÀWÀ on WhatsApp for bank details?", a: "For security. Bank details are never displayed on the website — sharing them only through our official WhatsApp protects you from fraud and ensures you receive the correct, current account information." },
  { q: "How is membership access activated after payment?", a: "Our team verifies your transfer, activates your membership and emails your confirmation. Your member area then shows your active membership, expiry date and unlocked A–Z collection." },
  { q: "How do I renew or cancel a membership?", a: "Memberships do not renew automatically and there is nothing to cancel — access simply ends on your expiry date. To continue, use the renewal button in your member area: it opens WhatsApp with a prefilled renewal request, and your new period begins once the renewal payment is verified." },
  { q: "Can I access the guides on mobile?", a: "Yes — the entire platform, including members-only collections, is designed for phones, tablets and desktop." },
  { q: "How can I contact the concierge?", a: "WhatsApp us any time at +234 915 437 9303, email info@jawaafrica.com, or use the enquiry form — every submission reaches the team directly." },
];
export const CONTACT = {
  email: "info@jawaafrica.com",
  phoneDisplay: "+234 915 437 9303",
};

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const JOURNEYS = [
  {
    id: "investor",
    title: "The Investor",
    kicker: "Invest",
    text: "Explore investment interests, market context and on-the-ground support — clear-eyed orientation before you commit capital.",
    image: IMAGES.personaChika,
    audience: "investor",
  },
  {
    id: "tourist",
    title: "The Tourist",
    kicker: "Visit",
    text: "Destinations, attractions, food, culture and hospitality — travel Africa the way it deserves to be experienced.",
    image: IMAGES.personaIvy,
    audience: "tourist",
  },
  {
    id: "returnee",
    title: "The Returnee & Relocator",
    kicker: "Return",
    text: "Coming home or moving for good — housing, schools, mobility and everyday logistics, handled calmly.",
    image: IMAGES.journeyReturnee,
    audience: "returnee",
  },
  {
    id: "expat",
    title: "The Expat",
    kicker: "Settle",
    text: "Moving for work, family or a new chapter — accommodation, local services and cultural orientation for a confident landing.",
    image: IMAGES.personaGlenn,
    audience: "expat",
  },
];

export const DESTINATIONS_FEATURED = [
  { slug: "nigeria", name: "Nigeria", tag: "36 States + FCT", image: IMAGES.lagos, span: "wide" },
  { slug: "abuja", name: "Abuja", tag: "Nigeria · Federal Capital", image: IMAGES.abuja, span: "square" },
  { slug: "kigali", name: "Kigali", tag: "Rwanda", image: IMAGES.kigali, span: "square" },
  { slug: "accra", name: "Accra", tag: "Ghana", image: IMAGES.accra, span: "square" },
  { slug: "cape-town", name: "Cape Town", tag: "South Africa", image: IMAGES.capeTown, span: "square" },
  { slug: "zanzibar", name: "Zanzibar", tag: "Tanzania · The Islands", image: IMAGES.zanzibar, span: "wide" },
];

export const NIGERIA_STATES = [
  "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue", "Borno",
  "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT Abuja", "Gombe",
  "Imo", "Jigawa", "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi", "Kwara",
  "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau",
  "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara",
];

export const stateSlug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const stateHref = (s) =>
  s === "Lagos" ? "/destinations/lagos" : s === "FCT Abuja" ? "/destinations/abuja" : `/destinations/state/${stateSlug(s)}`;

// State / FCT administrative centres (for destination profiles)
export const STATE_CAPITALS = {
  Abia: "Umuahia", Adamawa: "Yola", "Akwa Ibom": "Uyo", Anambra: "Awka", Bauchi: "Bauchi",
  Bayelsa: "Yenagoa", Benue: "Makurdi", Borno: "Maiduguri", "Cross River": "Calabar",
  Delta: "Asaba", Ebonyi: "Abakaliki", Edo: "Benin City", Ekiti: "Ado-Ekiti", Enugu: "Enugu",
  Gombe: "Gombe", Imo: "Owerri", Jigawa: "Dutse", Kaduna: "Kaduna", Kano: "Kano",
  Katsina: "Katsina", Kebbi: "Birnin Kebbi", Kogi: "Lokoja", Kwara: "Ilorin",
  Lagos: "Ikeja", Nasarawa: "Lafia", Niger: "Minna", Ogun: "Abeokuta", Ondo: "Akure",
  Osun: "Osogbo", Oyo: "Ibadan", Plateau: "Jos", Rivers: "Port Harcourt", Sokoto: "Sokoto",
  Taraba: "Jalingo", Yobe: "Damaturu", Zamfara: "Gusau", Abuja: "Abuja (Federal Capital Territory)",
};

export const EXPERIENCES = [
  { name: "Dining & Rooftops", image: IMAGES.dining, href: "/experiences#tour-food-discovery" },
  { name: "Culture & Art", image: IMAGES.cultureArt, href: "/experiences#tour-art-crafts-culture" },
  { name: "Fashion & Style", image: IMAGES.weddingAgbada, href: "/experiences#tour-adire-textiles" },
  { name: "Wellness & Spa", image: IMAGES.marrakech, href: "/experiences" },
  { name: "Family", image: IMAGES.familyLuxury, href: "/experiences" },
  { name: "Owambẹ & Events", image: IMAGES.weddingReception, href: "/experiences#tour-live-music-nightlife" },
  { name: "Staycations", image: IMAGES.coupleLifestyle, href: "/services" },
  { name: "Beaches & Islands", image: IMAGES.zanzibar, href: "/experiences#tour-beach-outing" },
  { name: "City Life", image: IMAGES.cityStyle, href: "/experiences#tour-lagos-highlights" },
  { name: "Wedding Elegance", image: IMAGES.weddingIgbo, href: "/services" },
];

// The 9 bookable JAWA+ services — names, descriptions and links verified against jawaafrica.com/bookings-list
// ---- Tours & experiences catalogue (launch estimates — reviewed against delivery costs before final confirmation) ----
// basis: "person" = per person | "group" = per private group up to group_size guests.
// image: "" renders a branded JÀWÀ cover block rather than an unrelated photo.
const IMG = {
  lagosCity: U("photo-1771495604392-2008757fb32a"),
  lagosSunny: U("photo-1618828665347-d870c38c95c7"),
  lagosAerial: U("photo-1618828665013-580e2baba4d0"),
  lagosSocial: U("photo-1731475761027-0b6b33b74547"),
  cultureArt: U("photo-1721751143747-8c6b1e2e4e36"),
  dining: U("photo-1681762700522-b4d252b7b09d"),
  events: U("photo-1724866976376-4b217d29a462"),
  nightlife: U("photo-1770012585495-b120dbaa77a9"),
  abuja: U("photo-1741991110666-88115e724741"),
  crafts: U("photo-1730882957986-432b853ff12f"),
  planning: U("photo-1573497019418-b400bb3ab074"),
};

export const EXPERIENCE_TOURS = [
  // --- Lagos ---
  { id: "lagos-highlights", title: "Lagos Guided City Highlights", destination: "Lagos", duration: "2–3 hours", price: 45, basis: "person", groupSize: null, image: IMG.lagosSunny,
    blurb: "The essential first look: Victoria Island, Ikoyi and the Lagos story in one guided sweep.",
    includes: "Vetted JÀWÀ local guide and route planning", excludes: "Entry fees, refreshments and transport (quoted when you book)" },
  { id: "lagos-half-day", title: "Private Lagos City Tour — Half Day", destination: "Lagos", duration: "Half day (≈4 hours)", price: 150, basis: "group", groupSize: 4, image: IMG.lagosCity,
    blurb: "Your own private half-day circuit with a JÀWÀ host — landmarks, stories and local stops at your pace.",
    includes: "Private JÀWÀ host, planned route", excludes: "Entry fees, food and transport (quoted at booking)" },
  { id: "lagos-full-day", title: "Private Lagos City Tour — Full Day", destination: "Lagos", duration: "Full day (≈8 hours)", price: 250, basis: "group", groupSize: 4, image: IMG.lagosSocial,
    blurb: "The whole city, properly: mainland to island, markets to museums, with time to breathe between stops.",
    includes: "Private JÀWÀ host, full-day planned route", excludes: "Entry fees, food and transport (quoted at booking)" },
  { id: "lagos-island-heritage", title: "Lagos Island Heritage & Architecture Tour", destination: "Lagos Island", duration: "≈3 hours", price: 55, basis: "person", groupSize: null, image: IMAGES.lagos,
    blurb: "Colonial facades, Brazilian-quarter history and the stories behind Lagos Island's streets.",
    includes: "Vetted local guide", excludes: "Entry fees and refreshments" },
  { id: "art-crafts-culture", title: "Art, Crafts & Nigerian Culture Experience", destination: "Lagos", duration: "≈3 hours", price: 55, basis: "person", groupSize: null, image: IMAGES.cultureArt,
    blurb: "Galleries, craft makers and contemporary Nigerian art — with context you won't get alone.",
    includes: "Vetted local guide and gallery coordination", excludes: "Purchases and any gallery entry fees" },
  { id: "food-discovery", title: "Nigerian Food Discovery", destination: "Lagos", duration: "≈3 hours", price: 65, basis: "person", groupSize: null, image: IMAGES.dining,
    blurb: "From bukka classics to contemporary Nigerian kitchens — taste your way through the city with a host.",
    includes: "Vetted food host and curated stops", excludes: "Food and drink purchases (budget guidance provided)" },
  { id: "markets-shopping", title: "Markets, Textiles & Shopping with a Guide", destination: "Lagos", duration: "≈3 hours", price: 50, basis: "person", groupSize: null, image: "/tour-balogun-market.jpg", imgAlt: "Balogun Market, Lagos Island — fabric and textile stalls and traders (photo: Wikimedia Commons, CC BY-SA 4.0)",
    blurb: "Navigate Lagos's markets with someone who knows the prices, the etiquette and the good stalls.",
    includes: "Vetted market guide", excludes: "Purchases and transport" },
  { id: "lekki-conservation", title: "Lekki Conservation Centre / LUFASI Guided Outing", destination: "Lekki, Lagos", duration: "Half day", price: 55, basis: "person", groupSize: null, image: "/tour-lekki-conservation.jpg", imgAlt: "The canopy walkway at Lekki Conservation Centre, Lagos (photo: Ashirow, Wikimedia Commons, CC BY-SA 4.0)",
    blurb: "Canopy walkways and Lagos's green side, with logistics handled for you.",
    includes: "JÀWÀ coordination and guide", excludes: "Entry fees (unconfirmed — confirmed at booking) and transport" },
  { id: "afrobeat-heritage", title: "Fela Kuti & Afrobeat Heritage Experience", destination: "Lagos", duration: "≈3 hours", price: 65, basis: "person", groupSize: null, image: "/tour-fela-kuti.jpg", imgAlt: "Fela Kuti performing, circa 1986 (public domain, distributed by Celluloid Records)",
    blurb: "The sound of a movement: Afrobeat's Lagos story, from the Kalakuta legacy to today's scene.",
    includes: "Vetted culture host", excludes: "Venue entry fees and refreshments" },
  { id: "live-music-nightlife", title: "Live Music & Nightlife with a Host", destination: "Lagos", duration: "Evening", price: 75, basis: "person", groupSize: null, image: "/detty-lagos-cover.jpg", imgAlt: "Guests at a stylish Lagos rooftop lounge with a live concert stage across the water",
    blurb: "Lagos after dark, done properly — a vetted host, the right rooms and a plan for getting home.",
    includes: "Vetted nightlife host and venue planning", excludes: "Tickets, drinks and purchases (unconfirmed until booked)" },
  { id: "beach-outing", title: "Beach Outing with Organised Transport", destination: "Lagos coast", duration: "Half or full day", price: 75, basis: "person", groupSize: null, image: IMAGES.zanzibar,
    blurb: "A proper beach day with the getting-there sorted — boats or road, timed and arranged.",
    includes: "Organised return transport and JÀWÀ coordination", excludes: "Beach entry, food and drink" },
  { id: "bespoke-lagos", title: "Private Bespoke Lagos Itinerary", destination: "Lagos", duration: "Your dates", price: 150, basis: "group", groupSize: 4, pricePrefix: "From ", image: IMG.planning,
    blurb: "A private itinerary built around your interests, group and pace — see the Essential, Signature and Premium planning tiers for larger trips.",
    includes: "Tailored plan and coordination", excludes: "Third-party costs (entries, food, transport)" },
  // --- Day trips from Lagos ---
  { id: "badagry-day", title: "Badagry Heritage Day Trip", destination: "Badagry (from Lagos)", duration: "Full day", price: 250, basis: "group", groupSize: 4, image: IMAGES.cultureArt,
    blurb: "A heavy, important day: the slave-route heritage sites of Badagry with a knowledgeable guide.",
    includes: "Private group guiding and day planning", excludes: "Transport and entry fees (quoted at booking)" },
  { id: "olumo-abeokuta", title: "Olumo Rock & Abeokuta Day Trip", destination: "Abeokuta (from Lagos)", duration: "Full day", price: 250, basis: "group", groupSize: 4, image: IMAGES.journeyTourist,
    blurb: "Climb Olumo Rock, see the Olusegun Obasanjo Presidential Library grounds and Abeokuta's adire heritage.",
    includes: "Private group guiding and day planning", excludes: "Transport and entry fees (quoted at booking)" },
  // --- Abuja & beyond ---
  { id: "abuja-highlights", title: "Abuja City Highlights — Half-Day Private Tour", destination: "Abuja", duration: "Half day", price: 150, basis: "group", groupSize: 4, image: IMG.abuja,
    blurb: "The capital's landmarks — Aso Rock views, the National Mosque and National Church, Millennium Park — with a private host.",
    includes: "Private JÀWÀ host and planned route", excludes: "Entry fees, food and transport (quoted at booking)" },
  { id: "ushafa-pottery", title: "Ushafa Pottery & Craft Experience", destination: "Ushafa, FCT", duration: "≈3 hours", price: 55, basis: "person", groupSize: null, image: IMAGES.weddingAgbada,
    blurb: "The famous pottery village — meet the makers and try the wheel.",
    includes: "Vetted local guide and village coordination", excludes: "Purchases and transport" },
  { id: "gurara-day", title: "Gurara Waterfalls Day Trip", destination: "Niger State (from Abuja)", duration: "Full day", price: 250, basis: "group", groupSize: 4, image: IMAGES.kigali,
    blurb: "One of Nigeria's great waterfalls, as a managed private day out from Abuja.",
    includes: "Private group guiding and day planning", excludes: "Transport and entry fees (quoted at booking)" },
  { id: "ibadan-heritage", title: "Ibadan Heritage & City Highlights — Half Day", destination: "Ibadan", duration: "Half day", price: 130, basis: "group", groupSize: 4, image: IMAGES.accra,
    blurb: "Cocoa House, Mapo Hall and the old city's stories — Nigeria's largest city by land, properly introduced.",
    includes: "Private group guiding", excludes: "Transport and entry fees (quoted at booking)" },
  { id: "adire-textiles", title: "Adire Textile & Craft Experience", destination: "Abeokuta / Osogbo", duration: "≈3 hours", price: 55, basis: "person", groupSize: null, image: IMAGES.shopping,
    blurb: "Learn the indigo art of adire with practising artisans — and make a piece to take home.",
    includes: "Artisan workshop coordination", excludes: "Materials beyond a take-home piece, and transport" },
  { id: "osogbo-day", title: "Osogbo Cultural & Heritage Day Trip", destination: "Osogbo (from Lagos or Ibadan)", duration: "Full day", price: 250, basis: "group", groupSize: 4, image: IMAGES.weddingYoruba,
    blurb: "The Osun-Osogbo Sacred Grove and the city's remarkable art legacy.",
    includes: "Private group guiding and day planning", excludes: "Transport and entry fees (quoted at booking)" },
];

export const TOUR_ESTIMATE_NOTE =
  "Launch estimate — the final price is confirmed when we confirm your date and arrangements. Per-person and per-group pricing shown on each tour; additional guests beyond the included group size are quoted before you pay.";

// ---- Family journeys (illustrative, anonymised — the situations JÀWÀ helps families navigate) ----
export const FAMILY_JOURNEYS = [
  { id: "cross-border-education", title: "Cross-border schooling, one eye on a UK university",
    image: IMAGES.childrenSchool,
    situation: "A family weighing secondary education across two countries, with a UK university pathway as the long-term goal.",
    challenge: "Which Nigerian schools keep that pathway open? Curriculum choices, exam boards and the timing of any move.",
    jawa: "School research and shortlist support, plus relocation planning around the school calendar.",
    service: { label: "School research support", href: "/services" } },
  { id: "weekly-boarding-relocation", title: "Relocating to Nigeria with a weekly-boarding plan",
    image: IMAGES.professionalsMixed,
    situation: "A UK independent-school family moving to Nigeria — a mother who travels for work, a father in Lagos's oil and gas sector, and children who need stability.",
    challenge: "Weekly boarding options, family logistics across two work schedules, and a soft landing for the children.",
    jawa: "School shortlists, arrival and settling-in support, and vetted domestic-staff guidance.",
    service: { label: "Relocation consultation", href: "/consultations" } },
  { id: "wellbeing-ageing-parents", title: "The right school — and the right life around it",
    image: IMAGES.familyLuxury,
    situation: "A family choosing a school while balancing children's wellbeing, ageing parents and the practicalities of family life in a new city.",
    challenge: "School fit beyond league tables: pastoral care, commute reality, and support for three generations.",
    jawa: "School research, neighbourhood guidance and household-setup support.",
    service: { label: "Relocation planning", href: "/services" } },
  { id: "semi-retirement", title: "Semi-retiring to Nigeria after decades in Australia",
    image: IMAGES.staycation,
    situation: "A family considering a slower chapter in Nigeria after many years in Australia.",
    challenge: "Healthcare access, banking and pensions practicalities, housing, and rebuilding a social life.",
    jawa: "Relocation consultations, banking and settlement guidance, and community connections.",
    service: { label: "Returnee journey", href: "/journeys/returnee" } },
  { id: "additional-learning-needs", title: "Finding the right support for a child with additional learning needs",
    image: IMAGES.relocationFamily,
    situation: "A family who will not move until they're confident their child's learning support continues properly.",
    challenge: "Which schools genuinely deliver the right provision — beyond the brochure.",
    jawa: "Careful, honest school research and direct questions asked on the family's behalf.",
    service: { label: "School research support", href: "/services" } },
  { id: "burnout-build-home", title: "Burnout, a property decision, and a plan to build",
    image: IMAGES.investor,
    situation: "A family managing burnout while making big calls on property, investments and building a home in Nigeria.",
    challenge: "Sequencing it all without expensive mistakes: where to buy, what to build, and who to trust on the ground.",
    jawa: "Property search support and introductions, plus investment-orientation consultations.",
    service: { label: "Property search support", href: "/services" } },
  { id: "christmas-home", title: "Building a Lagos home — Christmas 2026 first visit, relocation in 2027",
    image: IMAGES.modernApartment,
    situation: "A family purchasing, building and furnishing a home in Lagos, planning a Christmas 2026 visit and a possible move in 2027.",
    challenge: "Managing a build from abroad, furnishing in time, and turning a holiday visit into a trial run.",
    jawa: "Property introductions, on-the-ground coordination and a bespoke itinerary for the Christmas visit.",
    service: { label: "Bespoke itinerary", href: "/services" } },
];

export const FAMILY_JOURNEYS_NOTE =
  "Illustrative, anonymised family journeys — shared to show the situations JÀWÀ helps families navigate. They are examples, not verified testimonials.";

export const JAWA_SERVICES = [
  {
    name: "JAWA CONNECT",
    text: "Monthly themed networking events for returnees, tourists, and investors.",
    image: IMAGES.womenSocial,
    mode: "link",
    href: "/community",
    cta: "Open",
  },
  {
    name: "JAWA STAY",
    text: "Verified shortlets and longer stays — we confirm the actual listing, inclusions and availability before you commit.",
    image: IMAGES.staycation,
    price_note: "From $50/night or $700/month on verified listings.",
    mode: "enquiry",
    cta: "Enquire",
  },
  {
    name: "JAWA TOURIST",
    text: "SIM card, arrival toolkit and a vetted driver — your first hour handled, with pickup and concierge options.",
    image: IMAGES.airport,
    price_note: "Airport pickup from $45 per trip · arrival assistance from $75 · VIP airport concierge from $150 per arrival — inclusions confirmed before payment.",
    mode: "enquiry",
    cta: "Enquire",
  },
  {
    name: "JAWA RELOCATION",
    text: "30-day concierge support for new returnees settling into Lagos.",
    image: IMAGES.relocationFamily,
    price_note: "Relocation planning consultation from $100 · banking & settlement guidance from $75 · domestic staff sourcing from $150 (scope-dependent).",
    mode: "enquiry",
    cta: "Enquire",
  },
  {
    name: "JAWA HEALTH",
    text: "A guide to Lagos hospitals, clinics, emergency care, and insurance options.",
    image: IMAGES.marrakech,
    mode: "enquiry",
    cta: "Enquire",
  },
  {
    name: "JAWA STAYCATIONS",
    text: "Discover cool locations in Nigeria.",
    image: IMAGES.zanzibar,
    mode: "link",
    href: "/experiences",
    cta: "Explore tours",
  },
  {
    name: "JAWA DRIVE",
    text: "Trusted rides with vetted drivers — enquiry-led so availability is confirmed first.",
    image: IMAGES.lagos,
    price_note: "Lagos saloon from $75 (up to 12 hrs) · Lagos SUV from ₦150,000 · outside Lagos from ₦250,000.",
    mode: "enquiry",
    cta: "Enquire",
  },
  {
    name: "JAWA INVESTMENT",
    text: "The Investor A–Z Nigeria guide — researched opportunities across all 36 states and the FCT, organised by capital level.",
    image: IMAGES.professionalsMixed,
    mode: "link",
    href: "/guides",
    cta: "View the guide",
  },
  {
    name: "JAWA 1-2-1",
    text: "Private video consultations from 15 to 60 minutes — team sessions or founder sessions with Elizabeth, booked in West Africa Time.",
    image: IMAGES.concierge,
    mode: "link",
    href: "/consultations",
    cta: "Book a consultation",
  },
];

// The real A–Z JÀWÀ services directory. Website enquiry is the primary route;
// genuine third-party resources keep their external links.
export const SERVICES_DIRECTORY = [
  { title: "Accommodation", text: "Hotel and shortlet matching — we'll help you find a stylish, secure Lagos apartment.", mode: "enquiry", price_note: "From $50/night on verified listings.", cta: "Enquire" },
  { title: "Banking & Transfers", text: "Bank account opening, international transfers and currency exchange — we have you covered.", href: "https://referral.lemfi.com/Jx1DRi1WVYb", cta: "Get £10 Free" },
  { title: "Concierge & Personal Assistants", text: "Local help to run errands, book cars and handle paperwork — we take away the stress.", mode: "enquiry", price_note: "Bespoke support — quoted after enquiry.", cta: "Enquire" },
  { title: "Domestic Staff & Artisans", text: "Vetted nannies, chefs, cleaners, drivers, carpenters and plumbers — live-in or live-out.", mode: "enquiry", price_note: "From $150, subject to scope.", cta: "Enquire" },
  { title: "Entertainment", text: "Restaurants, lounges, beach clubs, concerts, boat cruises and tourist gems — never miss the best of Lagos.", mode: "link", href: "/experiences", cta: "Tours & experiences" },
  { title: "Food", text: "Trusted bukas, restaurants and lounges — from quick amala deliveries to premium dining.", mode: "link", href: "/experiences", cta: "Food experiences" },
  { title: "Groceries, Supermarket & Delivery", text: "Supermarkets, fresh food and dispatch services — local or international groceries, online or in person.", href: "https://glovo.go.link/?adj_t=vanu045", cta: "Get Free Delivery" },
  { title: "Healthcare", text: "The right hospitals, clinics, pharmacies and natural alternatives — plus health insurance guidance.", mode: "enquiry", cta: "Ask the concierge" },
  { title: "Investment Opportunities", text: "The Investor A–Z Nigeria guide — real estate, agriculture, startups and more across 36 states + FCT.", mode: "link", href: "/guides", cta: "View the guide" },
  { title: "Jobs, Freelancers & Side Hustles", text: "A community of remote and local diaspora-friendly jobs, gigs and side-hustle plugs.", mode: "link", href: "/community", cta: "Join the community" },
  { title: "Kids Education & Activities", text: "Daycares, international schools, holiday clubs and family-friendly hangouts — we help you choose well.", mode: "enquiry", price_note: "School research & shortlist support from $150.", cta: "Enquire" },
  { title: "Legal, NIN & Immigration", text: "Land purchase lawyers, business registration, NIN, visa and passport signposting — with verified partners. We never promise immigration outcomes.", href: "https://passport.immigration.gov.ng/", cta: "Official portal" },
  { title: "Mobility & Transport", text: "Car rentals with drivers, private boat rental, airport pickup, dispatch riders and trains.", mode: "enquiry", price_note: "Saloon from $75 (up to 12 hrs) · SUV from ₦150,000 · outside Lagos from ₦250,000.", cta: "Enquire" },
  { title: "Networking & Community", text: "Events, mixers, WhatsApp groups and premium networking gatherings for the JÀWÀ tribe.", mode: "link", href: "/community", cta: "Join the community" },
  { title: "Owambẹ", text: "From society weddings to celebrity birthdays — access to the most exclusive Lagos events, plus a glam squad for your asoẹbi.", mode: "enquiry", cta: "Enquire" },
  { title: "Property & Real Estate", text: "Rentals, buying, investment or shortlets — find your stylish, secure Lagos home with guided support.", mode: "enquiry", price_note: "Property search support & introductions from $150 (initial defined service).", cta: "Enquire" },
];

export const JOURNAL_POSTS = [
  {
    title: "Detty December, done properly",
    kicker: "Destinations",
    text: "December in Lagos sells out by autumn. How to plan flights, stays, drivers and the events actually worth your December — without the tourist traps.",
    image: IMAGES.lagosSocial,
    slug: "detty-december-done-properly",
  },
  {
    title: "The returnee's first 30 days",
    kicker: "Advice",
    text: "SIM, NIN, banking, housing viewings and school questions — the exact order of operations our relocation concierge walks families through, week by week.",
    image: IMAGES.journeyReturnee,
    slug: "returnees-first-30-days",
  },
  {
    title: "Why Nigeria's A–Z starts at the airport",
    kicker: "Experiences",
    text: "Immigration, SIM cards, pickups and the first hour on the ground. The thinking behind our free Nigerian Airport Guide — and how to land like a local.",
    image: IMAGES.airportTravel,
    slug: "az-starts-at-the-airport",
  },
];

// Full editorial articles for /journal — original JÀWÀ content
export const JOURNAL_ARTICLES = [
  {
    slug: "detty-december-done-properly",
    title: "Detty December, done properly",
    category: "Destinations",
    date: "October 2026",
    image: IMAGES.lagosSocial,
    excerpt:
      "December in Lagos sells out by autumn. How to plan flights, stays, drivers and the events actually worth your December — without the tourist traps.",
    body: [
      "Every December, Lagos becomes one of the busiest party cities on earth — and every December, thousands of visitors learn the same lesson the hard way: the people who enjoy Detty December most are the ones who planned it in October.",
      "Flights are the first squeeze. Fares into Murtala Muhammed International climb sharply from late November, and the best-value seats are usually gone by early autumn. If you are travelling with family or on specific dates, book before the prices do their annual jump.",
      "Accommodation is the second. Shortlets in Lekki, Victoria Island and Ikoyi range from excellent to fictional — photos lie, and December is when the gap between listing and reality matters most. Verified stays with real reviews, or a concierge who has actually stood in the apartment, are worth more than a marginal saving.",
      "Then the logistics nobody posts about: a trusted driver on the nights that matter, realistic travel times across the Third Mainland at rush hour, cash and card backups, and a SIM sorted on day one rather than day four.",
      "Finally, the events themselves. Lagos publishes hundreds of parties, concerts and beach days every December — the art is choosing ten worth your energy, not forty worth a flyer. Our Detty December guide keeps a curated, dated shortlist for exactly that reason.",
      "Plan early, verify what you book, and keep the logistics boring. That is what leaves the fun part of December free to be fun.",
    ],
  },
  {
    slug: "returnees-first-30-days",
    title: "The returnee's first 30 days",
    category: "Return & Relocation",
    date: "October 2026",
    image: IMAGES.journeyReturnee,
    excerpt:
      "SIM, NIN, banking, housing viewings and school questions — the exact order of operations our relocation concierge walks families through, week by week.",
    body: [
      "The first month back is a logistics problem disguised as a homecoming. Get the order of operations right and the month is energising; get it wrong and you spend it in queues.",
      "Week one is about being reachable and legal: a Nigerian SIM registered to you, your NIN confirmed or enrolled, and a working way to pay for things while your banking is sorted. None of this is glamorous — all of it unlocks everything else.",
      "Week two is banking and money: opening or reactivating accounts, setting up the apps Lagos actually runs on, and understanding how transfers, POS agents and cash fit together day to day.",
      "Weeks three and four are where families feel the difference: housing viewings with honest area advice, school questions answered before term deadlines, and the household setup — power backup, water, domestic help — that turns a rented address into a functioning home.",
      "The pattern we see across returning families is simple: the paperwork is survivable, but surprises are expensive. A checklist beats improvisation every single time.",
      "Our Returnee A–Z collection and relocation concierge exist for exactly this month — the order of operations, the honest answers, and the people to call when a queue says no.",
    ],
  },
  {
    slug: "az-starts-at-the-airport",
    title: "Why Nigeria's A–Z starts at the airport",
    category: "Travel Planning",
    date: "October 2026",
    image: IMAGES.airportTravel,
    excerpt:
      "Immigration, SIM cards, pickups and the first hour on the ground. The thinking behind our free Nigerian Airport Guide — and how to land like a local.",
    body: [
      "Ask anyone who visits Nigeria regularly where a trip is won or lost and you will get the same answer: the first hour after landing. Immigration, luggage, SIM cards, the pickup — get that hour right and the rest of the trip starts calm.",
      "That is why our free Airport Guide exists. Not because airports are complicated, but because arriving tired, uninformed and unmet is how good trips get bad first impressions.",
      "The practical pillars are unglamorous: documents ready before you reach the desk, a working data connection within minutes of landing, a pickup that is confirmed rather than hoped for, and knowing which official channels to use for anything else.",
      "First-time visitors are often surprised by how warm the arrivals hall actually is once you are prepared — and how much of the stress they were warned about evaporates with a plan.",
      "The guide is free because arrival should never be the hard part. Download it before you fly, land like you have done it before, and let Lagos introduce itself properly.",
    ],
  },
  {
    slug: "school-research-diaspora-families",
    title: "School research for diaspora families: how to shortlist with confidence",
    category: "Return & Relocation",
    date: "October 2026",
    image: IMAGES.journeyInvestor,
    excerpt:
      "Fees, curricula, admissions calendars and the questions that actually matter — how families relocating to Nigeria approach the school search without panic.",
    body: [
      "For most relocating families, the school decision drives everything else — where you live, when you move, even whether the move happens this year or next. It deserves a method, not a panic.",
      "Start with curriculum fit: British, American, IB and Nigerian curricula all have strong Lagos options, and the right choice depends on where your children are coming from and where they may go next.",
      "Then the admissions calendar. Good schools fill early, assessments have fixed windows, and mid-year entry is possible but narrower. Families who begin a term ahead have options; families who begin a month ahead have compromises.",
      "Visit if you can — and if you cannot, ask better questions. Staff turnover, class sizes, safeguarding policy, communication with parents abroad, and how the school handles children adjusting to a new country tell you more than any brochure.",
      "Our free School Guide was written for exactly this stage: the questions to ask, the timelines to respect and the shortlist discipline that turns an overwhelming search into a confident decision.",
    ],
  },
  {
    slug: "eating-lagos-first-timers-map",
    title: "Eating Lagos: a first-timer's map of the essentials",
    category: "Culture & Living",
    date: "October 2026",
    image: IMAGES.dining,
    excerpt:
      "From party jollof to suya at midnight — the dishes, habits and unwritten rules that make eating in Lagos a highlight rather than a hazard.",
    body: [
      "Lagos runs on food. Not just restaurants — though the rooftop and fine-dining scene is genuinely excellent — but the whole culture of eating: owambe jollof at a party, suya from a grill at midnight, amala at noon in a canteen with no sign.",
      "The essentials are non-negotiable. Party jollof, smoky from the firewood pot. Suya — beef or chicken, heavy on the yaji spice, wrapped in paper. Amala with ewedu and gbegiri for the brave. Pepper soup when the evening cools. Bole and roasted fish on the island.",
      "A few unwritten rules help: the busiest spot is usually the best sign, lunch hours are sacred, and 'small chops' at any event are never to be underestimated.",
      "For visitors, the only real caution is water and ice — drink sealed bottled water and you can be adventurous with almost everything else.",
      "Our curated dining lists on the Experiences page cover the restaurants; this is about the food itself. Come hungry, follow the crowds, and let Lagos feed you properly.",
    ],
  },
];
